import React, { FC } from 'react';
import './FieldbackField.css';
import { ErrorMessage } from '@/Shared/Lib/Logic';
import { FaRegStar, FaStar } from 'react-icons/fa';

interface FieldbackFieldProps {
	label: string,
	name: string,
	readOnly?: boolean
	required?: boolean
	value?: any
	onIconClick: (value: number) => void
}

const FieldbackField: FC<FieldbackFieldProps> = ({
	label, name, readOnly = false,
	required = false, value, onIconClick
}) => {
	return (
		<label
			className={`FieldbackField data-field-label ${readOnly ? 'readonly' : ''}`}
			data-testid="FieldbackField"
			title={readOnly ? 'Champ non modifiable' : 'Champ modifiable'}>
			<div>{label} {required && <span className="asterisk" aria-hidden="true"> *</span>}</div>
			<div className="form-group">
				<div className='Field-wrapper'>
					<div className="icon-wrapper">
						{Array.from({ length: 5 }, (_, i) => {
							const starValue = i + 1;
							const Icon = starValue <= Number(value) ? FaStar : FaRegStar;

							return (
								<Icon
									key={starValue}
									title={`${starValue} étoile${starValue > 1 ? 's':''}`}
									onClick={() => !readOnly && onIconClick(starValue)}
									style={{ cursor: readOnly ? 'default' : 'pointer' }}
								/>
							);
						})}
					</div>
				</div>
				<ErrorMessage name={name} component="div" className="error-message" />
			</div>
		</label>
	);
}

export default FieldbackField;
